import { Pipe, PipeTransform } from '@angular/core';

/**
 * parentheses pipe
 *
 * Usage in the template file:
 * {{ 'my.key' | translate | parentheses }}
 *
 */
@Pipe({
    name: 'parentheses',
    standalone: false
})
export class ParenthesesPipe implements PipeTransform {
    /**
     *
     * @param string The string to wrap in parentheses
     *
     * @returns updated string in parentheses
     */
    transform(key: string): string {
        return `(${key})`;
    }
}
